import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'ctfo-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent {
  @Output() ctfoDialogCloseEmitter = new EventEmitter<void>();
}
